export const ERROR_MESSAGES: any = {
  payTaxesBodies: 'Pay Taxes request body',
};
